// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__MlYTD","listItem":"styles_listItem___ah4c"};